/**
 * Chat Page - Slack-like UI
 * Main chat interface with channels, messages, and presence.
 * WebSocket connects only when user opens this page (clicks Chat).
 */

import React, { useEffect } from 'react';
import { ChatLayout } from '../components/chat/ChatLayout';
import { useChatWebSocket } from '../contexts/ChatWebSocketContext';
import { useActivityTracker } from '../hooks/useActivityTracker';
import { useAuth } from '../contexts/AuthContext';

const Chat: React.FC = () => {
  const { user } = useAuth();
  const { connect, disconnect } = useChatWebSocket();

  // Start WebSocket only when user opens Chat; disconnect when they leave
  useEffect(() => {
    if (user) {
      connect();
    }
    return () => {
      disconnect();
    };
  }, [user, connect, disconnect]);

  // Track user activity for auto-status
  useActivityTracker({
    enabled: !!user,
    pingInterval: 30000,
    awayTimeout: 300000,
  });

  if (!user) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        Please log in to use chat
      </div>
    );
  }

  return <ChatLayout />;
};

export default Chat;
